import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import "./LanguageSwitcher.css";

const LANGUAGES = [
    { code: "en", label: "EN", full: "English" },
    { code: "fr", label: "FR", full: "Français" },
    { code: "zh", label: "普通話", full: "Mandarin (Traditional Chinese)" },
];

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const current =
        LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

    const handleSelect = (code) => {
        i18n.changeLanguage(code);
        setOpen(false);
    };

    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    return (
        <div className="lang-switcher" ref={ref}>
            <button
                className="lang-switcher__btn"
                onClick={() => setOpen((o) => !o)}
                aria-label="Change language"
                aria-expanded={open}
            >
                <FontAwesomeIcon
                    icon={faGlobe}
                    className="lang-switcher__icon"
                />
                <span className="lang-switcher__label">{current.label}</span>
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`lang-switcher__arrow ${open ? "lang-switcher__arrow--open" : ""}`}
                />
            </button>

            {open && (
                <div className="lang-switcher__dropdown">
                    {LANGUAGES.map((lang) => (
                        <button
                            key={lang.code}
                            className={`lang-switcher__option ${lang.code === i18n.language ? "lang-switcher__option--active" : ""}`}
                            onClick={() => handleSelect(lang.code)}
                        >
                            <span className="lang-switcher__option-code">
                                {lang.label}
                            </span>
                            <span className="lang-switcher__option-full">
                                {lang.full}
                            </span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;
